<div class="video-container">
  <video
    #videoplayer
    disablepictureinpicture
    [controlsList]="controls"
    [style.object-fit]="objectFit"
    [class.mat-elevation-z8]="shadow"
    crossorigin="anonymous"
    oncontextmenu="return false;"
  >
    @if (media) {
      <source [src]="media" type="video/mp4" />
    }
    @if (caption) {
      <track [src]="caption.url" [label]="caption.label" kind="captions" />
    }
  </video>

  @if (showPlay) {
    <div class="play-btn">
      <button
        mat-icon-button
        (click)="pause = !pause"
        data-cy="video-play-pause"
        [matTooltip]="(pause ? 'Play' : 'Pause') | translate"
        matTooltipPosition="below"
        color="accent"
      >
        <mat-icon>{{
          pause ? "play_circle_filled" : "pause_circle_filled"
        }}</mat-icon>
      </button>
    </div>
  }

  @if (showMute) {
    <div class="mute-btn">
      <button
        mat-icon-button
        (click)="mute = !mute"
        [matTooltip]="(mute ? 'Unmute' : 'Mute') | translate"
        matTooltipPosition="below"
        color="accent"
      >
        <mat-icon>{{ mute ? "volume_off" : "volume_up" }}</mat-icon>
      </button>
    </div>
  }
</div>
